import { Tabs } from 'src/design/molecules/Tabs';
import React from 'react';
import { Header } from 'src/design/organisms/Header';
import { ByJobActivity } from './components/ByJobActivity';
import { ByUserActivity } from './components/ByUserActivity';

export const Activity: React.FC = () => {
  return (
    <>
      <Header
        title="Activity Feed"
        breadcrumbProps={{
          items: [{ text: 'Activity Feed' }],
        }}
        helpText="View activity by job or by user"
      />

      <Tabs defaultValue="by-job" mt="md">
        <Tabs.List>
          <Tabs.Tab value="by-job">By Job</Tabs.Tab>
          <Tabs.Tab value="by-user">By User</Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value="by-job">
          <ByJobActivity />
        </Tabs.Panel>

        <Tabs.Panel value="by-user">
          <ByUserActivity />
        </Tabs.Panel>
      </Tabs>
    </>
  );
};
